import { connect } from 'react-redux';
import { translate } from '../../../../base/i18n/functions';
import AbstractButton from '../../../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../../../base/dialog/actions';
import StartRecordingDialog from './StartRecordingDialog';
import StopRecordingDialog from './StopRecordingDialog';
import { IconRecord, IconStop } from '../../../../base/icons/svg';
import { sendAnalytics } from '../../../../analytics/functions';
import { createToolbarEvent } from '../../../../analytics/AnalyticsEvents';
import { JitsiRecordingConstants } from '../../../../base/lib-jitsi-meet';
import { MEET_FEATURES } from '../../../../base/jwt/constants';
import { maybeShowPremiumFeatureDialog } from '../../../../jaas/actions.web';
import { canStopRecording, getRecordButtonProps } from '../../../functions';
/**
 * Component that renders a toolbar button for the whiteboard.
 */
class RecordingButton extends AbstractButton {
    accessibilityLabel = 'dialog.startRecording';
    toggledAccessibilityLabel = 'dialog.stopRecording';
    icon = IconRecord;
    label = 'toolbar.accessibilityLabel.recording';
    toggledIcon = IconStop;
    toggledLabel = 'toolbar.accessibilityLabel.recording';
    toggledTooltip = 'dialog.stopRecording';
    tooltip = 'dialog.startRecording';
    /**
     * Handles clicking / pressing the button, and opens / closes the whiteboard view.
     *
     * @private
     * @returns {void}
     */
    async _handleClick() {
        const { _isRecordingRunning, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('recording.button', {
            'is_recording': _isRecordingRunning,
            type: JitsiRecordingConstants.mode.FILE
        }));
        const dialogShown = await dispatch(maybeShowPremiumFeatureDialog(MEET_FEATURES.RECORDING));
        if (!dialogShown) {
            this._onHandleClick();
        }
    }
    /**
    * Helper function to be implemented by subclasses, which should be used
    * to handle the start recoding button being clicked / pressed.
    *
    * @protected
    * @returns {void}
    */
    _onHandleClick() {
        const { _isRecordingRunning, dispatch } = this.props;
        dispatch(openDialog(_isRecordingRunning ? 'StopRecordingDialog' : 'StartRecordingDialog', _isRecordingRunning ? StopRecordingDialog : StartRecordingDialog));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isRecordingRunning;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { disabled: _disabled, tooltip: _tooltip, visible } = getRecordButtonProps(state);
    return {
        _isRecordingRunning: canStopRecording(state),
        visible: visible
    };
}
export default translate(connect(_mapStateToProps)(RecordingButton));
